export const callStatus = {
  PENDING: 'PENDING',
  IN_PROCESS: 'IN_PROCESS',
  FAILED: 'FAILED',
  SUCCESS: 'SUCCESS',
  FAILED_GET: 'FAILED_GET',
  EXPIRED: 'EXPIRED',
  REFRESH: 'REFRESH',
};
